import { useInfiniteQuery } from '@tanstack/react-query';
import { getWorkersForSelect } from './api';
import { workersForSelect } from './key';
import { transformWorkerToOption } from './selector';
import type { Category, Worker, WorkersResponse } from './type';
export const useWorkersForSelect = (searchText: string, disabledPersonIds: Set<string>, category?: Category, options?: {
  enabled?: boolean;
  isIndividual?: boolean;
  excludeNotHaveWorkerEmail?: boolean;
}) => {
  const isIndividual = options?.isIndividual ?? false;
  const result = useInfiniteQuery<WorkersResponse>({
    enabled: options?.enabled ?? true,
    queryKey: workersForSelect.workers(searchText, category, isIndividual, options?.excludeNotHaveWorkerEmail),
    queryFn: ({
      pageParam
    }) => getWorkersForSelect(searchText, pageParam as number, category, {
      isIndividual,
      excludeNotHaveWorkerEmail: options?.excludeNotHaveWorkerEmail
    }),
    initialPageParam: 1,
    /**
     * ※ getNextPageParam が undefined を返しても fetch が止まらない状況があるので注意
     *  getNextPageParam が undefined を返すと、「これ以上データがない」と判断し、次のページの fetch を自動的には行わない。
     * ※ fetchNextPage を手動で呼び出すと、undefined が返っていても fetch が継続してしまう
     *  fetchNextPage は「次のページがあるかどうか」をチェックせずに強制的に queryFn を実行するため、停止条件が効かなくなる
     */
    getNextPageParam: lastPage => {
      return lastPage.page < lastPage.maxPage ? lastPage.page + 1 : undefined;
    }
  });
  return {
    ...result,
    data: result.data?.pages.flatMap((page: WorkersResponse) => page.items.map((worker: Worker) => transformWorkerToOption(worker, disabledPersonIds))) || [],
    fetchNextPage: result.fetchNextPage,
    hasNextPage: result.hasNextPage,
    isFetching: result.isFetching
  };
};